export default "__VITE_ASSET__C5XUC18n__"